import React from 'react';

export const RebalanceSearchFiltersContainer = (): JSX.Element => {
  return <div>TODO Rebalance Filters Container</div>;
};
